import { WATERFALL2_PAGE_SIZE } from './utils';

interface WaterFall2InitialSkeletonProps {
  animated?: boolean;
  columns?: 1 | 2;
  columnGap?: number;
}

const SINGLE_COLUMN_IMAGE_HEIGHT = WATERFALL2_PAGE_SIZE * 281;
// 含价格/评价与 20px 色系关联行（当前真实结构至少约 93px）的保守上界。
const SINGLE_COLUMN_CARD_CHROME_HEIGHT = 96;
const ITEM_GAP = 12;
// 含 section padding、标题/副标题和 Tab 行。
const SECTION_CHROME_HEIGHT = 128;

/**
 * dynamic 边界拿不到组件列数；用真实单列商品比例保守预留首包高度。
 * 占位不参与滚动锚定，避免代码块替换时浏览器把空占位选作锚点。
 */
export function WaterFall2ColdReturnPlaceholder() {
  const fixedHeight =
    WATERFALL2_PAGE_SIZE * SINGLE_COLUMN_CARD_CHROME_HEIGHT +
    (WATERFALL2_PAGE_SIZE - 1) * ITEM_GAP +
    SECTION_CHROME_HEIGHT;

  return (
    <div
      aria-hidden
      data-testid="waterfall2-cold-return-placeholder"
      className="w-full bg-white"
      style={{ overflowAnchor: 'none' }}
    >
      <div className="w-full" style={{ aspectRatio: `375 / ${SINGLE_COLUMN_IMAGE_HEIGHT}` }} />
      <div style={{ height: fixedHeight }} />
    </div>
  );
}

/** 使用 WaterFall2 自身的图片比例渲染首包加载态，不依赖通用商品骨架。 */
export default function WaterFall2InitialSkeleton({
  animated = true,
  columns = 2,
  columnGap = 4,
}: WaterFall2InitialSkeletonProps) {
  return (
    <div
      data-testid="waterfall2-skeleton"
      aria-hidden
      className="grid"
      style={{
        gridTemplateColumns: columns === 1 ? 'minmax(0, 1fr)' : 'repeat(2, minmax(0, 1fr))',
        columnGap: columns === 1 ? 0 : columnGap,
        rowGap: ITEM_GAP,
        overflowAnchor: 'none',
      }}
    >
      {Array.from({ length: WATERFALL2_PAGE_SIZE }, (_, index) => {
        const imageAspectRatio =
          columns === 1 ? '375 / 281' : index % 5 === 0 ? '185.5 / 230.22' : '1 / 1';
        return (
          <div key={index} className={`w-full ${animated ? 'animate-pulse' : ''}`}>
            <div
              data-waterfall2-skeleton-image
              className="w-full bg-[#f5f5f5]"
              style={{ aspectRatio: imageAspectRatio }}
            />
            <div
              data-waterfall2-skeleton-info
              className="px-[6px] pb-[20px] pt-[8px]"
              style={{ height: SINGLE_COLUMN_CARD_CHROME_HEIGHT }}
            >
              <div className="h-[14px] w-2/3 rounded-[2px] bg-[#f5f5f5]" />
              <div className="mt-[8px] h-[14px] w-1/2 rounded-[2px] bg-[#f5f5f5]" />
              <div className="mt-[8px] h-[20px] w-1/3 rounded-[2px] bg-[#f5f5f5]" />
            </div>
          </div>
        );
      })}
    </div>
  );
}
